module.exports = "/fonts/ProductSans-Bold.woff?0e179021d036d6dacfbaacc50c0bd627";